import { render, staticRenderFns } from "./HalfTime.vue?vue&type=template&id=12864c6b&"
import script from "./HalfTime.vue?vue&type=script&lang=js&"
export * from "./HalfTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports